import React from 'react';
import WorkspacePage from '../components/layout/WorkspacePage';
import Button from '../components/ui/Button';
import './UnauthorizedPage.css';

function ModuleNotEnabledPage({ moduleName = 'This module', onGoHome }) {
  return (
    <WorkspacePage
      width="operational"
      data-workspace-id="module-not-enabled"
      title="Module Not Enabled"
      subtitle={`${moduleName} is currently disabled for this tenant.`}
    >
      <section className="unauthorized-page" data-testid="module-not-enabled-page">
        <div className="unauthorized-page__card">
          <span className="unauthorized-page__eyebrow">Tenant Module Enablement</span>
          <h1>{moduleName} is not enabled</h1>
          <p>
            This workspace is hidden for the current tenant configuration. Enable the module in
            Tenant Configuration to make its routes, navigation, and widgets available again.
          </p>
          <div className="unauthorized-page__actions">
            <Button onClick={onGoHome}>Return to my dashboard</Button>
          </div>
        </div>
      </section>
    </WorkspacePage>
  );
}

export default ModuleNotEnabledPage;
